import React from 'react';

const Notificacion = props => (
  <div className="newAut-slides-item">
    <p>La solicitud de autorización excepcional N° {props.codSolicitud} ha sido {props.action}.</p>
    <p>Le llegarán notificaciones a las siguientes personas:</p>
    <ul>
      {
        props.colaboradoresSeleccionados.map(colaborador => (
          <li>{colaborador.nombres}</li>
        ))
      }
    </ul>
  </div>
);

export default Notificacion;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitudExcepcional/Notificacion.js